import React from 'react';
import './KombosComponent.css';

const KombosComponent = () => {
    const onceOffBundles = [
        { data: "1GB", minutes: "100 min", price: "R49" },
        { data: "2GB", minutes: "200 min", price: "R89" },
        { data: "5GB", minutes: "500 min", price: "R169" },
        { data: "10GB", minutes: "1,000 min", price: "R299" },
    ];

    const dailyIntegratedBundles = [
        { data: "250MB", minutes: "10 min", price: "R99", description: "Delivered daily for 30 days" }
    ];

    return (
        <div className="kombos-container">
            <div className="kombos-card">
                <h2 className="kombos-title">STANDARD RATES</h2>
      <p style={{paddingBottom: "20px", textAlign: "center"}}>      <strong>k'nect bundles are available at all tills in-store, via USSD *135# or on Money Market Account.</strong>
      </p>

                {/* 30 Days Once-off Bundles Section */}
                <div className="kombos-section">
                    <div className="kombos-section-title">
                        30 Days Once-off Bundles
                    </div>

                    <div className="kombos-list">
                        {onceOffBundles.map((bundle, index) => (
                            <div key={index} className="kombos-row">
                                <span className="kombos-data">{bundle.data}</span>
                                <span className="kombos-minutes">{bundle.minutes}</span>
                                <span className="kombos-price">{bundle.price}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Daily Integrated Bundles Section */}
                <div className="kombos-section">
                    <div className="kombos-section-title">
                        Daily Integrated Bundles
                    </div>

                    <div className="kombos-list">
                        {dailyIntegratedBundles.map((bundle, index) => (
                            <>
                                <p style={{textAlign: "center"}}>{bundle.description}</p>

                                <div key={index} className="kombos-row">
                                    <span className="kombos-data">{bundle.data}</span>
                                    <span className="kombos-minutes">{bundle.minutes}</span>
                                    <span className="kombos-price">{bundle.price}</span>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KombosComponent;